import { IonButton, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../constants";
import { utilService } from "../../../services";
import "./CareTeamAlert.scss";

interface ContainerProps {
  showCareTeamAlert: boolean;
  showAlert: () => void;
  careTeamInputParams?: any;
}
const CareTeamAlert: React.FC<ContainerProps> = (props: any) => {
  const [alertMessage, setMessage] = useState("");
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [audio, setAudio] = useState(new Audio(CONSTANTS.ALERT_RINGTONE.ALERT));

  useEffect(() => {
    if (!utilService.isEmpty(props.careTeamInputParams)) {
      const data =
        props.careTeamInputParams && props.careTeamInputParams.data
          ? props.careTeamInputParams.data.body
          : "";
      const message = data !== "" ? data.slice(data.indexOf("!") + 1) : "";
      setMessage(message);
    }
  }, [props.careTeamInputParams]);

  useEffect(() => {
    if (props.showCareTeamAlert) {
      displayReminderAlert();
    }
  }, []);

  const displayReminderAlert = () => {
    setShowModalAlert(true);
    audio.load();
    audio.loop = true;
    audio.play();
  };

  const hideReminderAlert = () => {
    props.showAlert();
    audio.load();
    audio.loop = false;
    audio.pause();
  };

  return (
    <IonModal
      isOpen={showModalAlert}
      className="care-team-modal"
      backdropDismiss={false}
    >
      <div className="care-team-alert-main-container">
        <div className="content-area">
          <span className="icon-siren"></span>
          <span className="alert-title">Attention Urgent!</span>
          <span className="alert-message">{alertMessage}</span>
        </div>

        <div className="care-team-button-container">
          <div className="cancel-button-div"></div>
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                hideReminderAlert();
              }}
            >
              Ok
            </IonButton>
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default CareTeamAlert;
